/*
  Vanilla ports (no React, no GSAP) of three React Bits components — https://reactbits.dev
  React Bits © David Haz, MIT + Commons Clause (use in a website allowed; components not for resale).
  - ScrollReveal  -> [data-rb-scroll]  words light up and un-blur as you scroll, line straightens
  - BlurText      -> [data-rb-blur]    words drop in from a blur when they enter the screen
  - CircularText  -> [data-rb-circle="TEXT"]  spinning circular seal, speeds up on hover
*/
(function () {
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function split(el) {
    if (el.__rbw) return el.__rbw;
    var text = el.textContent; el.textContent = '';
    text.split(/([ \t\n\r]+)/).forEach(function (w) {
      if (!w) return;
      if (/^[ \t\n\r]+$/.test(w)) { el.appendChild(document.createTextNode(' ')); return; }
      var s = document.createElement('span'); s.className = 'rb-w'; s.textContent = w; el.appendChild(s);
    });
    el.__rbw = [].slice.call(el.querySelectorAll('.rb-w'));
    return el.__rbw;
  }

  function initBlur(root) {
    (root || document).querySelectorAll('[data-rb-blur]').forEach(function (el) {
      if (el.__rbb) return; el.__rbb = 1;
      var ws = split(el); if (reduce) return;
      el.classList.add('rb-blur');
      ws.forEach(function (w, i) { w.style.transitionDelay = (i * 0.07) + 's'; });
      if (!('IntersectionObserver' in window)) { el.classList.add('rb-in'); return; }
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { el.classList.add('rb-in'); io.disconnect(); } }, { threshold: 0.1 });
      io.observe(el);
    });
  }

  var scrollers = [];
  function initScroll(root) {
    (root || document).querySelectorAll('[data-rb-scroll]').forEach(function (el) {
      if (el.__rbs) return; el.__rbs = 1;
      var ws = split(el); if (reduce) return;
      el.classList.add('rb-scroll');
      scrollers.push({ el: el, ws: ws });
    });
    update();
  }
  var ticking = false;
  function update() {
    ticking = false;
    var vh = window.innerHeight;
    scrollers.forEach(function (o) {
      var r = o.el.getBoundingClientRect();
      var start = vh * 0.95, end = vh * 0.4;
      var p = (start - r.top) / (start - end); p = p < 0 ? 0 : p > 1 ? 1 : p;
      o.el.style.transform = 'rotate(' + (2.5 * (1 - p)).toFixed(3) + 'deg)';
      var n = o.ws.length;
      o.ws.forEach(function (w, i) {
        var l = (p * (n + 3) - i) / 3; l = l < 0 ? 0 : l > 1 ? 1 : l;
        w.style.opacity = (0.12 + 0.88 * l).toFixed(3);
        w.style.filter = l >= 1 ? 'none' : 'blur(' + (4 * (1 - l)).toFixed(2) + 'px)';
      });
    });
  }
  window.addEventListener('scroll', function () { if (!ticking && scrollers.length) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
  window.addEventListener('resize', function () { if (scrollers.length) requestAnimationFrame(update); });

  function initCircle(root) {
    (root || document).querySelectorAll('[data-rb-circle]').forEach(function (el) {
      if (el.__rbc) return; el.__rbc = 1;
      var letters = Array.from(el.getAttribute('data-rb-circle'));
      var ring = document.createElement('span'); ring.className = 'rb-ring';
      letters.forEach(function (ch, i) {
        var s = document.createElement('span'); s.textContent = ch;
        s.style.transform = 'rotate(' + (360 / letters.length * i) + 'deg)';
        ring.appendChild(s);
      });
      el.insertBefore(ring, el.firstChild);
      if (reduce) return;
      var angle = 0, speed = 360 / 22, target = speed, last = performance.now();
      el.addEventListener('mouseenter', function () { target = speed * 4; });
      el.addEventListener('mouseleave', function () { target = speed; });
      var cur = speed;
      (function frame(t) {
        var dt = Math.min(0.05, (t - last) / 1000); last = t;
        cur += (target - cur) * 0.06; angle = (angle + cur * dt) % 360;
        ring.style.transform = 'rotate(' + angle.toFixed(2) + 'deg)';
        requestAnimationFrame(frame);
      })(last);
    });
  }

  function init(root) { initBlur(root); initScroll(root); initCircle(root); }
  window.zrBits = init;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
})();
